//import ClipboardJS   from '../../../node_modules/clipboard/dist/clipboard';
import MagnificPopup from '../../../node_modules/magnific-popup/dist/jquery.magnific-popup';
import Tracking      from './components/tracking.js';
import EventTracking from './components/event-tracking.js';
import CodeReveal    from './components/code-reveal.js';